export default __webpack_public_path__ + "static/media/maor-projects-on-devices-screen.f8f93d04.png";